export default "__VITE_ASSET__Ce9QVtJF__"